// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgrammesView_container__3hnJh"};